import { EvidenceTabContent } from '@pages/EvidencePage/EvidenceTabContent';
import { useCaseTasks } from '@queries/brokerCases/useCaseTasks';
import { usePrefetchDocumentReviews } from '@queries/brokerCases/usePrefetchDocumentReviews';

interface OoEvidencePageProps {
  caseId: string;
}

export function OoEvidencePage({ caseId }: OoEvidencePageProps) {
  const { data: caseTasksData, isLoading: isCaseTasksLoading } = useCaseTasks(caseId);
  const sections = caseTasksData?.sections ?? [];

  usePrefetchDocumentReviews(caseId, sections);

  return <EvidenceTabContent caseId={caseId} sections={sections} isCaseTasksLoading={isCaseTasksLoading} isEmbedded />;
}
